import React, { useEffect } from "react"
import Highlight from "@/components/core/Highlight/Highlight"
import { sanitizeText } from "@/utils/helper"

import styles from "@/components/Shared/Search/v1/InspirationTile/index.module.scss"

import noImage from "@/public/images/image-missing.png"
import { addProductNavigationAnalytics } from "@/components/Shared/Search/v1/InspirationTile/analytics"

const InspirationTile = props => {
  const {
    data,
    type,
    page,
    highlightText,
    id,
    onToggle = () => {},
    searchResultDataLayerObj = {},
  } = props

  const handleImageError = e => {
    e.target.src = noImage.src
  }

  useEffect(() => {
    window.wow?.sync()
  }, [])

  return (
    <div className={styles.inspirationTileWrapper}>
      <div className="inspiration-tile">
        <a
          data-gbh-data-layer=""
          id={id}
          tabIndex="-1"
          className="inspiration-tile__link gbh-data-layer"
          href={data.contentUrl}
          onClick={() => {
            onToggle()
            addProductNavigationAnalytics(
              data,
              type,
              page,
              searchResultDataLayerObj
            )
          }}
        >
          <div
            className={`inspiration-tile__container no-gutters wow animate__fadeInUp`}
          >
            <div className="inspiration-tile__left-section no-gutters">
              <div
                className={`inspiration-tile__left-section-container no-gutters`}
              >
                <div className="inspiration-tile__left-section-container__first-coloumn">
                  <div className="inspiration-tile__title">
                    <span className="inspiration-tile__category-name">
                      {data.categoryName}
                    </span>
                    <h3 className="inspiration-tile__article-title">
                      <Highlight
                        text={sanitizeText(data.title)}
                        highlight={highlightText}
                      />
                    </h3>
                    {data.subTitle && (
                      <h3 className="inspiration-tile__article-sub-title">
                        <Highlight
                          text={sanitizeText(data.subTitle)}
                          highlight={highlightText}
                        />
                      </h3>
                    )}
                  </div>
                </div>
                <div className="inspiration-tile__left-section-container__second-coloumn">
                  <div className="inspiration-tile__description">
                    <Highlight
                      text={sanitizeText(data.description)}
                      highlight={highlightText}
                    />
                  </div>
                </div>
              </div>
            </div>
            {data.imageUrl ? (
              <div className="inspiration-tile__right-section no-gutters">
                <img
                  className={`inspiration-tile__img`}
                  src={data.imageUrl ? data.imageUrl : noImage.src}
                  alt="inspiration-image"
                  onError={handleImageError}
                />
              </div>
            ) : (
              <div className="inspiration-tile__right-section no-gutters">
                <img
                  className={`inspiration-tile__img`}
                  src={noImage?.src}
                  alt="inspiration-image"
                  onError={handleImageError}
                />
              </div>
            )}
          </div>
        </a>
      </div>
    </div>
  )
}

export default InspirationTile
